import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { InvitationStatusType } from '@vi-iot/client';

import { GatewayInvitationsState, GatewayInvitationsStore, SearchParams } from '@store';

@Injectable({
  providedIn: 'root',
})
export class GatewayInvitationsService {
  statusFilters: { value: string; name: string }[];

  constructor(public store: GatewayInvitationsStore, private translation: TranslateService) {
    this.translation.onLangChange.subscribe(() => {
      this.setStatusFilters();
    });

    this.setStatusFilters();
  }

  selectInvitations(): Observable<GatewayInvitationsState> {
    return this.store.state$;
  }

  listGatewayInvitations(params: SearchParams): void {
    this.store.listGatewayInvitations(params);
  }

  filterByStatus(params: SearchParams): void {
    this.store.filterByStatus(params);
  }

  clearStore(): void {
    this.store.clearStore();
  }

  private setStatusFilters(): void {
    this.statusFilters = [
      {
        value: '',
        name: this.translation.instant('GATEWAY.INVITATION_LIST.FILTER.ALL'),
      },
      {
        value: InvitationStatusType.Accepted,
        name: this.translation.instant('GATEWAY.INVITATION_LIST.FILTER.ACCEPTED'),
      },
      {
        value: InvitationStatusType.Canceled,
        name: this.translation.instant('GATEWAY.INVITATION_LIST.FILTER.CANCELED'),
      },
      {
        value: InvitationStatusType.Expired,
        name: this.translation.instant('GATEWAY.INVITATION_LIST.FILTER.EXPIRED'),
      },
      {
        value: InvitationStatusType.Pending,
        name: this.translation.instant('GATEWAY.INVITATION_LIST.FILTER.PENDING'),
      },
      {
        value: InvitationStatusType.Rejected,
        name: this.translation.instant('GATEWAY.INVITATION_LIST.FILTER.REJECTED'),
      },
      {
        value: InvitationStatusType.Terminated,
        name: this.translation.instant('GATEWAY.INVITATION_LIST.FILTER.TERMINATED'),
      },
    ];
  }
}
